// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationEnterBankAccountPath = 'M12 40.744A10.6 10.6 0 016 34.6l-2.8-7.8L50 4.1l46.8 22.7-2.8 7.8a10.6 10.6 0 01-6 6.144V75.5h5.5v7h-87v-7H12V40.744zM81 75.5v-34H19v34h62zM12.6 32.2l-.7-1.9L50 11.9l38.1 18.4-.7 1.9a3.5 3.5 0 01-3.3 2.3H66.736c-1.417-7.958-8.37-14-16.736-14-8.365 0-15.32 6.042-16.736 14H15.9a3.5 3.5 0 01-3.3-2.3zM50 27.5c4.478 0 8.268 2.943 9.542 7H40.458c1.274-4.057 5.064-7 9.542-7zm-21 35a5 5 0 100-10 5 5 0 000 10zm14 0a5 5 0 100-10 5 5 0 000 10zm14 0a5 5 0 100-10 5 5 0 000 10zm19-5a5 5 0 11-10 0 5 5 0 0110 0zm24 38v-7H0v7h100z';
var IllustrationEnterBankAccount = baseIllustration('IllustrationEnterBankAccount', {
  getPath: () => IllustrationEnterBankAccountPath
}, 'ColoredIllustrationEnterBankAccount');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationEnterBankAccount;
//# sourceMappingURL=index.js.map